import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic, Table, Typography, Tag, Spin, Alert } from 'antd';
import { DollarOutlined, RiseOutlined, FallOutlined, WalletOutlined } from '@ant-design/icons';
import { apiClient as api } from '../../../shared/api/axios-instance';
import { ReconciliationStatus } from '../components/ReconciliationStatus';

const { Title } = Typography;

export const FinancialsOverviewScreen: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [summary, setSummary] = useState<any>(null);

    useEffect(() => {
        fetchSummary();
    }, []);

    const fetchSummary = async () => {
        try {
            setLoading(true);
            const response = await api.get('/admin/financials/wallet-summary');
            setSummary(response.data.data);
            setError(null);
        } catch (err: any) {
            setError(err.response?.data?.message || 'Failed to fetch financial summary');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;
    if (error) return <Alert message="Error" description={error} type="error" showIcon />;

    return (
        <div>
            <Title level={2}>Financial Overview</Title>
            
            <Row gutter={[16, 16]}>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="Total Wallet Recharges"
                            value={summary?.total_recharges || 0}
                            precision={2}
                            prefix={<DollarOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="Total Wallet Consumption"
                            value={summary?.total_consumption || 0}
                            precision={2}
                            prefix={<FallOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="Outstanding Balance"
                            value={summary?.outstanding_balance || 0}
                            precision={2}
                            prefix={<WalletOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="Today's Recharges"
                            value={summary?.todays_recharges || 0}
                            precision={2}
                            prefix={<RiseOutlined />}
                        />
                    </Card>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="This Month Recharges"
                            value={summary?.this_month_recharges || 0}
                            precision={2}
                            prefix={<RiseOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="Pending Recharges"
                            value={summary?.pending_recharges_count || 0}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="Failed Recharges"
                            value={summary?.failed_recharges_count || 0}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col>
            </Row>

            <div style={{ marginTop: 24 }}>
                <ReconciliationStatus />
            </div>
        </div>
    );
};

